import { createAction, props } from '@ngrx/store';
import { DialogData } from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';


export const addZeitStart = createAction('ZEIT::ADD_ZEIT_START');
export const addZeitSucceeded = createAction('ZEIT::ADD_ZEIT_SUCCEEDED',
  props<{ item: DialogData }>());
export const addZeitFailed = createAction('ZEIT::ADD_ZEIT_FAILED', props<{ error: Error }>());
